import React, { useState, useEffect } from "react";
import BankAccountService from "../../../../../ops/modules/patients/modules/new-bridge/services/BankAccountService";
import EventService from "../../../../../../service/event/EventService";

const ChequeImageViewer = ({ bankAccountResponse }) => {
  const [imageSrc, setImageSrc] = useState(null);
  const bankAccountService = new BankAccountService();

  const BANK_ACCOUNT_VERIFICATION_STATUS_VERIFIED = 1;
  const BANK_ACCOUNT_VERIFICATION_STATUS_UNVERIFIED = 0;
  const BANK_ACCOUNT_VERIFICATION_STATUS_REJECTED = 2;

  useEffect(() => {
    const handleKeyDown = (e) => {
      // Block Ctrl+S and Ctrl+P
      if ((e.ctrlKey || e.metaKey) && (e.key === "s" || e.key === "p")) {
        e.preventDefault();
        alert("Saving/Printing is disabled for security.");
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  const fetchSecureImage = async () => {
    bankAccountService.fetchChequeFile(
      bankAccountResponse?.id,
      async (response) => {
        if (!response.ok) {
          EventService.emit("showError", {
            message: "Failed to fetch the cancelled cheque",
          });
        }

        try {
          const blob = await response.blob();

          const objectURL = URL.createObjectURL(blob);
          setImageSrc(objectURL);

          // CLEANUP: Revoke the URL when the component unmounts
          // This tells the browser to wipe the file from memory
          // return () => URL.revokeObjectURL(objectURL);
        } catch (err) {
          EventService.emit("showError", {
            message: "Error loading the cancelled cheque",
          });
        }
      },
      (err) => {
        EventService.emit("showError", {
          message: "Error loading the cancelled cheque : " + err.toString(),
        });
      }
    );
  };

  useEffect(() => {
    if (
      bankAccountResponse?.id &&
      Boolean(
        bankAccountResponse?.verificationStatus ===
          BANK_ACCOUNT_VERIFICATION_STATUS_UNVERIFIED
      )
    ) {
      fetchSecureImage();
    }
  }, [bankAccountResponse]);

  return (
    <div style={{ width: "100%" }}>
      {imageSrc ? (
        <img
          src={imageSrc}
          alt="Cancelled Cheque"
          onContextMenu={(e) => e.preventDefault()} // Basic right-click disable
          style={{ userSelect: "none", pointerEvents: "none", width: "100%" }} // Disable dragging
        />
      ) : (
        <p>Loading document...</p>
      )}
    </div>
  );
};

export default ChequeImageViewer;
